// https://lancedikson.github.io/bowser/docs
import Bowser from 'bowser'
import BowserUtils from 'bowser/src/utils'

export function getPlatform(ua) {
  if (!ua) {
    if (typeof window !== 'undefined') {
      ua = window.navigator.userAgent
    } else {
      return {}
    }
  }

  const platform = Bowser.parse(ua)
  platform.ua = ua

  if (platform.browser) {
    platform.browser.alias = BowserUtils.getBrowserAlias(platform.browser.name)
  }

  return platform
}

export const platform = getPlatform()
